import INVENTORY_API_BASE_URL from "../../config/api";
import "./createlist.css";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import Multiselect from "multiselect-react-dropdown";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const Createlisting = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { form, isEditing } = location.state || {};
  const [title, setTitle] = useState("");
  const [Medium, setMedium] = useState("");
  const [permalink, setpermalink] = useState("");
  const [Hsncode, setHsncode] = useState("49011010");
  const [length, setlength] = useState();
  const [width, setwidth] = useState();
  const [height, setheight] = useState();
  const [weight, setweight] = useState();
  const [sku, setsku] = useState("");
  const [subjects, setsubjects] = useState("");
  const [examCategory, setexamCategory] = useState([]);
  const [examName, setexamName] = useState([]);
  const [options, setOptions] = useState([
    "SSC",
    "Railway",
    "Police",
    "Teaching",
    "General",
    "CSAT",
    "CET",
    "CBSE 10th Exam",
  ]);

  const [options1, setOptions1] = useState([
    "SSC CGL Tier-1",
    "SSC CGL Tier-2",
    "SSC CHSL Tier-1",
    "SSC CHSL Tier-2",
    "RRB NTPC 1st Stage",
    "RRB ALP",
  ]);
  const [isbn, setisbn] = useState("");
  const [mrp, setmrp] = useState("");
  const [pinnacleSP, setpinnacleSP] = useState("");
  const [Search, setSearch] = useState("");
  const [Desc, setDesc] = useState("");
  const [date, setDate] = useState("");
  const [edition, setedition] = useState("");
  const [author, setauthor] = useState("");
  const [stock, setstock] = useState(50);
  const [Amazon, setAmazon] = useState("");
  const [Flipkart, setFlipKart] = useState("");
  const [Snapdeal, setSnapdeal] = useState("");
  const [AuthStatus, setAuthStatus] = useState("active");
  const [AFsku, setAFsku] = useState("");
  const [AMsku, setAMsku] = useState("");
  const [FMsku, setFMsku] = useState("");
  const [PWsku, setPWsku] = useState("");
  const [img, setImg] = useState();
  const [img2, setImg2] = useState();
  const [img3, setImg3] = useState();
  const [img4, setImg4] = useState();
  const [img5, setImg5] = useState();
  const [newOption, setNewOption] = useState("");
  const [newOption1, setNewOption1] = useState("");

  const handleNewOptionChange = (event) => {
    setNewOption(event.target.value);
  };

  const handleAddOption = () => {
    if (newOption.trim() !== "") {
      setOptions([...options, newOption]);
      setNewOption("");
    }
  };

  const handleRemoveOption = (selectedList, removedItem) => {
    if (selectedList.includes(removedItem)) {
      setOptions(selectedList);
    }
  };

  const handleSelect = (selectedList) => {
    setexamCategory(selectedList);
  };

  const handleNewOptionChange1 = (event) => {
    setNewOption1(event.target.value);
  };

  const handleAddOption1 = () => {
    if (newOption1.trim() !== "") {
      setOptions1([...options1, newOption1]);
      setNewOption1("");
    }
  };

  const handleRemoveOption1 = (selectedLis, removedIte) => {
    if (selectedLis.includes(removedIte)) {
      setOptions1(selectedLis);
    }
  };

  const handleSelect1 = (selectedLis) => {
    setexamName(selectedLis);
  };

  const mydate = useRef();

  let changeFormat = () => {
    setDate(mydate.current.value);
  };

  let dateWe = date.split("-");
  let nfo = `${dateWe[2]}-${dateWe[1]}-${dateWe[0]}`;

  useEffect(() => {
    if (isEditing && form) {
      setTitle(form.title);
      setMedium(form.Medium);
      setpermalink(form.permalink);
      setHsncode(form.Hsncode);
      setlength(form.length);
      setwidth(form.width);
      setheight(form.height);
      setweight(form.weight);
      setsku(form.sku);
      setsubjects(form.subjects);
      setexamCategory(form.examCategory);
      setexamName(form.examName);
      setisbn(form.isbn);
      setmrp(form.mrp);
      setpinnacleSP(form.pinnacleSP);
      setSearch(form.Search);
      setDesc(form.Desc);
      setDate(form.date);
      setedition(form.edition);
      setauthor(form.author);
      setstock(form.stock);
      setAmazon(form.Amazon);
      setFlipKart(form.Flipkart);
      setSnapdeal(form.Snapdeal);
      setAuthStatus(form.AuthStatus);
      setAFsku(form.AFsku);
      setAMsku(form.AMsku);
      setFMsku(form.FMsku);
      setPWsku(form.PWsku);
      if (form.img) setImg(form.img);
      if (form.img2) setImg2(form.img2);
      if (form.img3) setImg3(form.img3);
      if (form.img4) setImg4(form.img4);
      if (form.img5) setImg5(form.img5);
    }
  }, [isEditing, form]);

  const handleApi = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("Medium", Medium);
    formData.append("permalink", permalink);
    formData.append("Hsncode", Hsncode);
    formData.append("length", length);
    formData.append("width", width);
    formData.append("height", height);
    formData.append("weight", weight);
    formData.append("sku", sku);
    formData.append("subjects", subjects);
    formData.append("examCategory", examCategory);
    formData.append("examName", examName);
    formData.append("isbn", isbn);
    formData.append("mrp", mrp);
    formData.append("pinnacleSP", pinnacleSP);
    formData.append("Search", Search);
    formData.append("Desc", Desc);
    formData.append("date", nfo);
    formData.append("edition", edition);
    formData.append("author", author);
    formData.append("stock", stock);
    formData.append("Amazon", Amazon);
    formData.append("Flipkart", Flipkart);
    formData.append("Snapdeal", Snapdeal);
    formData.append("AuthStatus", AuthStatus);
    formData.append("AFsku", AFsku);
    formData.append("AMsku", AMsku);
    formData.append("FMsku", FMsku);
    formData.append("PWsku", PWsku);
    formData.append("img", img);
    formData.append("img2", img2);
    formData.append("img3", img3);
    formData.append("img4", img4);
    formData.append("img5", img5);

    if (isEditing && form) {
      await Axios.put(
        `${INVENTORY_API_BASE_URL}/axis/${form._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      swal({
        title: "Listing Updated",
        text: "",
        icon: "success",
      });
      navigate("/Createlisting");
    } else {
      await Axios.post(`${INVENTORY_API_BASE_URL}/axis`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      swal({
        title: "Listing Created",
        text: "",
        icon: "success",
      });
    }

    setTitle("");
    setMedium("");
    setpermalink("");
    setHsncode("");
    setlength("");
    setwidth("");
    setheight("");
    setweight("");
    setsku("");
    setsubjects("");
    setexamCategory("");
    setexamName("");
    setisbn("");
    setmrp("");
    setpinnacleSP("");
    setSearch("");
    setDesc("");
    setDate("");
    setedition("");
    setauthor("");
    setstock("");
    setAmazon("");
    setFlipKart("");
    setSnapdeal("");
    setAuthStatus("");
    setAFsku("");
    setAMsku("");
    setFMsku("");
    setPWsku("");
    setImg("");
    setImg2("");
    setImg3("");
    setImg4("");
    setImg5("");
  };

  return (
    <main className="create-listing-page">
      <header className="create-listing-page__intro">
        <div>
          <p className="create-listing-page__eyebrow">STOCK &amp; CATALOG</p>
          <h1>{isEditing && form ? "Edit listing" : "Create listing"}</h1>
          <p className="create-listing-page__description">
            Maintain book details, publishing information, pricing, and marketplace links.
          </p>
        </div>
        <span className={"create-listing-page__status create-listing-page__status--" + (AuthStatus || "active")}>
          <span aria-hidden="true" />
          {AuthStatus === "upcoming_books" ? "Upcoming" : (AuthStatus || "active").charAt(0).toUpperCase() + (AuthStatus || "active").slice(1)}
        </span>
      </header>

      <section className="create-listing-form" aria-labelledby="heading">
        <div className="create-listing-form__header">
          <div>
            <span className="create-listing-form__eyebrow">LISTING DETAILS</span>
            <h2 id="heading">{isEditing && form ? "Edit book listing" : "New book listing"}</h2>
            <p>Complete the sections below, then save your catalog listing.</p>
          </div>
          <span className="create-listing-form__required"><strong>*</strong> Required field</span>
        </div>

        <form onSubmit={handleApi}>
          <div className="form-body">
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">01</span>
    <div>
      <h3>Book information</h3>
      <p>Titles, identifiers, subject, and physical dimensions.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <div className="title">
            <label className="form__label" htmlFor="title">
              Title{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :{" "}
            </label>
            <input
              className="form__input"
              type="text"
              id="titl"
              placeholder="Title"
              value={title}
              required
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>


          <label className="form__label" htmlFor="author">
            Medium{" "}
            <span
              style={{
                color: "red",
                fontSize: "50%",
                position: "relative",
                top: "-0.8em",
              }}
            >
              &#9733;
            </span>{" "}
            :
          </label>
          <input
            list="mediumOptions"
            name="Medium"
            value={Medium}
            className="ras"
            id="medm"
            onChange={(e) => {
              setMedium(e.target.value);
            }}
          />
          <datalist id="mediumOptions">
            <option value="English" />
            <option value="Hindi" />
            <option value="Bilingual" />
          </datalist>

          <div className="Permalink">
            <label className="form__label" htmlFor="Permalink">
              Permalink{" :"}
            </label>
            <input
              type="text"
              name=""
              id="Permalink"
              className="form__input"
              placeholder="Permalink"
              value={permalink}
              onChange={(e) => {
                const modifiedPerma = e.target.value.replace(/\s+/g, "-"); 
                setpermalink(modifiedPerma);
              }}
            />
          </div>
          <div className="price">
            <label className="form__label" htmlFor="Hsncode">
              HSN Code{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              type="text"
              id="HSN"
              className="form__input"
              placeholder="HSN Code"
              value={Hsncode}
              required
              onChange={(e) => {
                setHsncode(e.target.value);
              }}
            />
          </div>
          <div className="Length">
            <label className="form__label" htmlFor="Length">
              Length (cm){" :"}
            </label>
            <input
              className="form__input"
              type="number"
              id="Length"
              placeholder="Length"
              value={length}
              onChange={(e) => {
                setlength(e.target.value);
              }}
            />
          </div>
          <div className="Width">
            <label className="form__label" htmlFor="Width">
              Width (cm){" :"}
            </label>
            <input
              className="form__input"
              type="number"
              id="Width"
              placeholder="Width"
              value={width}
              onChange={(e) => {
                setwidth(e.target.value);
              }}
            />
          </div>
          <div className="Height">
            <label className="form__label" htmlFor="Height">
              Height (cm){": "}
            </label>
            <input
              className="form__input"
              type="number"
              id="Height"
              placeholder="Height"
              value={height}
              onChange={(e) => {
                setheight(e.target.value);
              }}
            />
          </div>
          <div className="Weight">
            <label className="form__label" htmlFor="Weight">
              Weight (gram){" :"}
            </label>
            <input
              className="form__input"
              type="number"
              id="Weight"
              placeholder="Weight"
              value={weight}
              onChange={(e) => {
                setweight(e.target.value);
              }}
            />
          </div>
          <div className="sku">
            <label className="form__label" htmlFor="sku">
              SKU Code on Books{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="text"
              id="sku"
              required
              placeholder="SKU code"
              value={sku}
              onChange={(e) => {
                const inputValue = e.target.value;
                const capitalizedFirstLetter =
                  inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                const modifiedTitle = capitalizedFirstLetter.replace(
                  /\s+/g,
                  "-",
                ); 
                setsku(modifiedTitle);
              }}
            />
          </div>
          <h4>Master SKU Code is : {sku}</h4>
          <div className="sku">
            <label className="formil" htmlFor="sku">
              Amazon FBA SKU {" :"}
            </label>
            <input
              className="form__input"
              type="text"
              id="afsku"
              placeholder="Amazon FBA SKU "
              value={AFsku}
              onChange={(e) => {
                setAFsku(e.target.value);
              }}
            />
          </div>
          <div className="sku">
            <label className="formil" htmlFor="sku">
              Amazon Merchant SKU{" :"}
            </label>
            <input
              className="form__input"
              type="text"
              id="amsku"
              placeholder="Amazon Merchant SKU"
              value={AMsku}
              onChange={(e) => {
                setAMsku(e.target.value);
              }}
            />
          </div>
          <div className="sku">
            <label className="formil" htmlFor="sku">
              Flipkart SKU {" :"}
            </label>
            <input
              className="form__input"
              type="text"
              id="fmsku"
              placeholder=" Flipkart Merchant SKU"
              value={FMsku}
              onChange={(e) => {
                setFMsku(e.target.value);
              }}
            />
          </div>

          <div className="sku">
            <label className="formil" htmlFor="sku">
              Pinnacle Website SKU {" :"}
            </label>
            <input
              className="form__input"
              type="text"
              id="PWsku"
              placeholder=" Pinnacle Website SKU"
              value={PWsku}
              onChange={(e) => {
                setPWsku(e.target.value);
              }}
            />
          </div>

          <label htmlFor="sb" className="form__label">
            Select Subject{" "}
            <span
              style={{
                color: "red",
                fontSize: "50%",
                position: "relative",
                top: "-0.8em",
              }}
            >
              &#9733;
            </span>{" "}
            :
          </label>
          <input
            type="text"
            name="subjects"
            className="form__input"
            list="subjectOptions"
            id="sb"
            required
            value={subjects}
            onChange={(e) => {
              setsubjects(e.target.value);
            }}
          />

          <datalist id="subjectOptions">
            <option value="Maths" />
            <option value="English" />
            <option value="GK-GS" />
            <option value="Reasoning" />
          </datalist>


  </div>
</section>
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">02</span>
    <div>
      <h3>Exam classification</h3>
      <p>Choose the relevant category and exam for this listing.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <div className="selen">
            <label htmlFor="exim" className="form__label">
              Exam Category{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>

            <Multiselect
              id="exom"
              isObject={false}
              required
              onRemove={handleRemoveOption}
              onSelect={handleSelect} // Call handleSelect when options are selected
              options={options}
            />
            <input
              type="text"
              value={newOption}
              className="addoption2"
              onChange={handleNewOptionChange}
              placeholder="Enter a new option"
            />
            <button
              className="addoption"
              type="button"
              onClick={handleAddOption}
            >
              Add Option
            </button>
            {isEditing && <p className="exCa">{examCategory}</p>}
          </div>
          <div className="selen">
            <label className="form__label">
              Exam Name{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <Multiselect
              id="exom"
              isObject={false}
              required
              onRemove={handleRemoveOption1}
              onSelect={handleSelect1} // Call handleSelect when options are selected
              options={options1}
            />
            <input
              type="text"
              className="addoption2"
              value={newOption1}
              onChange={handleNewOptionChange1}
              placeholder="Enter a new option"
            />
            <button
              className="addoption"
              type="button"
              onClick={handleAddOption1}
            >
              Add Option
            </button>
            {isEditing && <p className="exCa">{examName}</p>}
          </div>


  </div>
</section>
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">03</span>
    <div>
      <h3>Pricing and ISBN</h3>
      <p>Set the customer prices and book identifier.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <div className="isbn">
            <label className="form__label" htmlFor="isbn">
              ISBN code :
            </label>
            <input
              className="form__input"
              type="text"
              id="isbn"
              placeholder="ISBN code"
              value={isbn}
              onChange={(e) => {
                setisbn(e.target.value);
              }}
            />
          </div>
          <div className="mrp">
            <label className="form__label" htmlFor="mrp">
              MRP (Rs){" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="number"
              id="mrp"
              placeholder="MRP (Rs)"
              required
              value={mrp}
              onChange={(e) => {
                setmrp(e.target.value);
              }}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="spp">
            <label className="form__label" htmlFor="spp">
              Selling Price on Pinnacle{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="number"
              id="spp"
              placeholder="SP on Pinnacle website"
              value={pinnacleSP}
              required
              onChange={(e) => {
                setpinnacleSP(e.target.value);
              }}
            />
          </div>


  </div>
</section>
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">04</span>
    <div>
      <h3>Book images</h3>
      <p>Add a front image and any supporting product images.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <label className="form__label">
            <b>Add Images (PNG/JPG/PDF file)</b>
            <br></br>{" "}
          </label>
          <div>
            <label className="form__label" htmlFor="img">
              Image 1 (Front Side){" "}
              <span
                style={{
                  color: "red",
                  fontSize: "70%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              : ----------------------------------{" "}
            </label>
            <input
              className="form__input"
              type="file"
              accept="image/*"
              id="img1"
              {...(isEditing ? "" : "required")}
              name="img"
              onChange={(e) => {
                setImg(e.target.files[0]);
              }}
            />
            {isEditing && (
              <img
                src={`https://d10idqgatxnd06.cloudfront.net/${img}`}
                alt="Image1"
                style={{ width: "50px", height: "50px" }}
              />
            )}
          </div>
          <div>
            <label className="form__label" htmlFor="img2">
              Image 2----------------------------------------------------
            </label>
            <input
              className="form__input"
              type="file"
              accept="image/*"
              id="img2"
              name="img2"
              onChange={(e) => {
                setImg2(e.target.files[0]);
              }}
            />
            {isEditing && (
              <img
                src={img2}
                alt="Image2"
                style={{ width: "50px", height: "50px" }}
              />
            )}
          </div>

          <div>
            <label className="form__label" htmlFor="img3">
              Image 3----------------------------------------------------
            </label>
            <input
              className="form__input"
              type="file"
              accept="image/*"
              id="img3"
              name="img3"
              onChange={(e) => {
                setImg3(e.target.files[0]);
              }}
            />
            {isEditing && (
              <img
                src={img3}
                alt="Image3"
                style={{ width: "50px", height: "50px" }}
              />
            )}
          </div>

          <div>
            <label className="form__label" htmlFor="img4">
              Image 4----------------------------------------------------
            </label>
            <input
              className="form__input"
              type="file"
              accept="image/*"
              id="img4"
              name="img4"
              onChange={(e) => {
                setImg4(e.target.files[0]);
              }}
            />
            {isEditing && (
              <img
                src={img4}
                alt="Image4"
                style={{ width: "50px", height: "50px" }}
              />
            )}
          </div>

          <div>
            <label className="form__label" htmlFor="img5">
              Image 5----------------------------------------------------
            </label>
            <input
              className="form__input"
              type="file"
              accept="image/*"
              id="img5"
              name="img5"
              onChange={(e) => {
                setImg5(e.target.files[0]);
              }}
            />
            {isEditing && (
              <img
                src={img5}
                alt="Image5"
                style={{ width: "50px", height: "50px" }}
              />
            )}
          </div>


  </div>
</section>
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">05</span>
    <div>
      <h3>Publishing details</h3>
      <p>Add search keywords, description, date, edition, author, and status.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <label className="form__label" htmlFor="search">
            Search Keywords{" :"}
          </label>
          <input
            className="form__input"
            type="text"
            placeholder="Search.."
            name="search"
            id="sek"
            value={Search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <div>
            <label className="form__label" htmlFor="desc">
              {" "}
              Description :-
            </label>
            <br></br>
            <textarea
              id="desc"
              name="desc"
              rows="8"
              cols="50"
              value={Desc}
              onChange={(e) => {
                setDesc(e.target.value);
              }}
            ></textarea>
          </div>
          <div>
            <label className="form__label" htmlFor="p_date">
              {" "}
              Publishing Date{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>
              :{" "}
            </label>
            <input
              className="form__input"
              type="date"
              id="p_date"
              name="date"
              value={date}
              onChange={changeFormat}
              ref={mydate}
            />
            {isEditing && <p className="exCa">{date}</p>}
          </div>
          <div className="edition">
            <label className="form__label" htmlFor="edition">
              Edition{" :"}
            </label>
            <input
              className="form__input"
              type="text"
              id="edition"
              placeholder="Edition"
              value={edition}
              onChange={(e) => {
                setedition(e.target.value);
              }}
            />
          </div>
          <div className="author">
            <label className="form__label" htmlFor="author">
              Author :
            </label>
            <input
              className="form__input"
              type="text"
              id="author"
              placeholder="Author"
              value={author}
              onChange={(e) => {
                setauthor(e.target.value);
              }}
            />
          </div>
          <div className="rad">
            <input
              type="radio"
              id="active"
              name="author"
              value="active"
              className="ras"
              checked={AuthStatus === "active"}
              onChange={(e) => {
                setAuthStatus(e.target.value);
              }}
            />
            <label htmlFor="active"> Active</label>
            <input
              type="radio"
              id="inactive"
              name="author"
              value="inactive"
              className="ras"
              checked={AuthStatus === "inactive"}
              onChange={(e) => {
                setAuthStatus(e.target.value);
              }}
            />
            <label htmlFor="inactive"> InActive</label>
            <input
              type="radio"
              id="upcoming_books"
              name="author"
              value="upcoming_books"
              className="ras"
              checked={AuthStatus === "upcoming_books"}
              onChange={(e) => {
                setAuthStatus(e.target.value);
              }}
            />
            <label htmlFor="upcoming_books"> Upcoming_Books</label>
          </div>


  </div>
</section>
<section className="listing-form-section">
  <div className="listing-form-section__heading">
    <span className="listing-form-section__number">06</span>
    <div>
      <h3>Inventory and sales channels</h3>
      <p>Review the stock value and connect marketplace listings.</p>
    </div>
  </div>
  <div className="listing-form-section__fields">
          <div className="stock">
            <label className="form__label" htmlFor="stock">
              Coins :
            </label>
            <input
              className="form__input"
              type="number"
              id="stock"
              value={stock}
              readOnly
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="amazon_link">
            <label className="form__label" htmlFor="amazon_link">
              Amazon Link{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="text"
              id="amazon_link"
              required
              placeholder="Amazon Link"
              value={Amazon}
              onChange={(e) => {
                setAmazon(e.target.value);
              }}
            />
          </div>

          <div className="flipkart_link">
            <label className="form__label" htmlFor="flipkart_link">
              Flipkart Link{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="text"
              id="flipkart_link"
              required
              placeholder="Flipkart Link"
              value={Flipkart}
              onChange={(e) => {
                setFlipKart(e.target.value);
              }}
            />
          </div>

          <div className="snapdeal_link">
            <label className="form__label" htmlFor="snapdeal_link">
              Snapdeal Link{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "50%",
                  position: "relative",
                  top: "-0.8em",
                }}
              >
                &#9733;
              </span>{" "}
              :
            </label>
            <input
              className="form__input"
              type="text"
              id="snapdeal_link"
              required
              placeholder="Snapdeal Link"
              value={Snapdeal}
              onChange={(e) => {
                setSnapdeal(e.target.value);
              }}
            />
          </div>

          {isEditing ? (
            <b>Note:-Exam Category and Exam Name are same as at Submit time</b>
          ) : (
            <p></p>
          )}
  </div>
</section>
          </div>
          <div className="foot">
            <button className="btnn" type="submit">
              {isEditing ? "Update listing" : "Create listing"}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default Createlisting;
